/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataUserCouponInfoRespVo } from './PageDataUserCouponInfoRespVo';
import {
    PageDataUserCouponInfoRespVoFromJSON,
    PageDataUserCouponInfoRespVoFromJSONTyped,
    PageDataUserCouponInfoRespVoToJSON,
    PageDataUserCouponInfoRespVoToJSONTyped,
} from './PageDataUserCouponInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataUserCouponInfoRespVo
 */
export interface ResponsePageDataUserCouponInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataUserCouponInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataUserCouponInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataUserCouponInfoRespVo}
     * @memberof ResponsePageDataUserCouponInfoRespVo
     */
    data?: PageDataUserCouponInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataUserCouponInfoRespVo interface.
 */
export function instanceOfResponsePageDataUserCouponInfoRespVo(value: object): value is ResponsePageDataUserCouponInfoRespVo {
    return true;
}

export function ResponsePageDataUserCouponInfoRespVoFromJSON(json: any): ResponsePageDataUserCouponInfoRespVo {
    return ResponsePageDataUserCouponInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataUserCouponInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataUserCouponInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataUserCouponInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataUserCouponInfoRespVoToJSON(json: any): ResponsePageDataUserCouponInfoRespVo {
    return ResponsePageDataUserCouponInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataUserCouponInfoRespVoToJSONTyped(value?: ResponsePageDataUserCouponInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataUserCouponInfoRespVoToJSON(value['data']),
    };
}

